import ShipmentService from '../services/shipment.service';
import moment from 'moment'
import _ from 'lodash';
import { Converter } from "any-number-to-words";

let today = new Date();
const getDefaultState = () => {
  return {
    contract_id: "",
    contract_code_id: "",
    contract_code: "",
    invoice_code_id: "",
    invoice_code: "",
    invoice_date: moment(today).format("YYYY-MM-DD"),
    shipment_date: moment(today).format("YYYY-MM-DD"),
    inbound_date: moment(today).format("YYYY-MM-DD"),
    country_origin: "COUNTRY OF ORIGIN content",
    mean_transport: "MEANS OF TRANSPORT content",
    hawb_no: "HAWB NO content",
    port_landing: "PORT OF LOADING content",
    port_discharge: "PORT OF DISCHARGE content",
    for_account: "",
    risks_messrs: "",
    supplier_id: "",
    supplier_code: "",
    customer_id: "",
    customer_code: "",
    buy_currency: "",
    buy_exchange_rates: "",
    sell_currency: "",
    sell_exchange_rates: "",
    grand_total_buy_price: 0,
    grand_total_buy_text: "",
    grand_total_sell_price: 0,
    grand_total_sell_text: "",
    balance: null,
    invoice_detail_list: [],
    list_products: [],
    file_link_1: "",
    file_link_2: "",
    file_link_3: "",
    file_link_4: "",
    supplierInfo: {},
    customerInfo: {},
    receiving_voucher_date: moment(today).format("YYYY-MM-DD"),
    delivery_voucher_date: moment(today).format("YYYY-MM-DD"),
    delivery_voucher_no: "PXK-" + moment(today).format("YYMMDDhhmmss") + _.random(100, 999),
    receiving_voucher_no: "PNK-" + moment(today).format("YYMMDDhhmmss") + _.random(100, 999),
    error_lists: [],
    sub_total_buy: 0,
    sub_total_sell: 0,
    tax_total_buy: 0,
    tax_total_sell: 0,
    grand_total_buy_vnd: 0,
    grand_total_sell_vnd: 0,
  }
}

function calcTax(amount, product, type = 'buy') {
  let tax = 0;
  const prefix = type === 'buy' ? 'tax_buy_' : 'tax_sell_';

  [1, 2, 3].forEach(i => {
    const t = product[`${prefix}${i}`];

    if (t && t.is_display === true && Number(t.value) > 0) {
      const base = amount + tax;
      const currentTax = base * Number(t.value) / 100;
      tax += currentTax;
      // amount = Number(amount) + tax;
      // tax += amount * Number(t.value) / 100;
    }
  });

  return tax;
}

export const shipmentAdd = {
  namespaced: true,
  state: {
    stateData: getDefaultState(),
    isRecalculateLocked: false
  },
  actions: {
    resetState({commit}) {
      commit("resetState");
    },
    searchContract({commit}, {"page": page, "searchKey": searchKey}) {
      return ShipmentService.searchContract({"page": page, "searchKey": searchKey})
      .then(
        (response) => {
          // commit('searchProductSuccess', response);
          return Promise.resolve(response);
        },
        (error) => {
          commit('searchProductFailure');
          return Promise.reject(error);
        }
      );
    },
    // getPartnerInfo ({commit}, id="") {
    //   return ShipmentService.getPartnerInfo(id).then(
    //     (response) => {
    //       return Promise.resolve(response);
    //     },
    //     (error) => {
    //       commit('getPartnerFailure');
    //       return Promise.reject(error);
    //     }
    //   );
    // },
    async getPartnerInfo (_, id="") {
      return await ShipmentService.getPartnerInfo(id);
    },
    searchInvoiceRegByCode({commit}, {"page": page, "searchKey": searchKey}) {
      return ShipmentService.searchInvoiceRegByCode({"page": page, "searchKey": searchKey})
      .then(
        (response) => {
          commit('searchInvoiceRegSuccess', response);
          return Promise.resolve(response);
        },
        (error) => {
          commit('searchInvoiceRegFailure');
          return Promise.reject(error);
        }
      );
    },
    getContractInfo({commit}, id="") {
      return ShipmentService.getContractInfo(id).then(
        (response) => {
          commit('getContractSuccess', response);
          return Promise.resolve(response);
        },
        (error) => {
          commit('getContractFailure');
          return Promise.reject(error);
        }
      );
    },
    getShipmentQuantityRemain({commit}, id="") {
      return ShipmentService.getShipmentQuantityRemain(id).then(
        (response) => {
          commit('getShipmentQuantityRemainSuccess', response);
          // return Promise.resolve(response);
        },
        (error) => {
          commit('getShipmentQuantityRemainFailure');
          return Promise.reject(error);
        }
      );
    },
    saveShipment({commit}, data) {
      return ShipmentService.saveShipment(data).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit("saveShipmentFailure");
          return Promise.reject(error);
        }
      );
    },
    uploadShipmentFile({commit},formdata) {
			return ShipmentService.uploadShipmentFile(formdata).then(
				(response) => {
					commit('uploadSuccess', response);
					return Promise.resolve(response);
				},
				(error) => {
					commit("uploadFailure");
					return Promise.reject(error);
				}
			);
		},
    async loadContractShipmentData({ dispatch, commit }, contract) {
      // lock recalc during loading
      commit('setRecalculateLock', true);

      try {
        // Get Supplier
        try {
          const supplier = await dispatch(
            'getPartnerInfo',
            contract.supplier_id
          );
          commit('getSupplierInfoSuccess', supplier);
        } catch (error) {
          commit('getSupplierInfoFailed');
          console.error(error);
        }

        // Get Customer
        try {
          const customer = await dispatch(
            'getPartnerInfo',
            contract.customer_id
          );
          commit('getCustomerInfoSuccess', customer);
        } catch (error) {
          commit('getCustomerInfoFailed');
          console.error(error);
        }

        // Contract detail (list_products)
        await dispatch('getContractInfo', contract.id);

        // Quantity remain (mutate nhiều field → đã bị khóa)
        await dispatch('getShipmentQuantityRemain', contract.id);
      }
      finally {
        // 🔓 Mở khóa recalc
        commit('setRecalculateLock', false);
      }

      // Recalculate Grand Total
      dispatch('reCalculateGrandTotal');
    },
    reCalculateGrandTotal({ commit }) {
      commit("handleReCalculateGrandTotal");
    }
  },
  mutations: {
    resetState (state) {
      console.log("run resetState");
      Object.assign(state.stateData, getDefaultState())
    },
    searchInvoiceRegSuccess(state, response) {
			if(response.listItems.length > 0) {
        state.stateData.invoice_code_id = response.listItems[0].id;
        state.stateData.invoice_code = response.listItems[0].invoice_code;
			}
		},
		searchInvoiceRegFailure(state) {
			console.log("run searchInvoiceRegFailure");
			state.stateData.contract_code_id = "";
			state.stateData.contract_code = "";
		},
    getContractSuccess(state, response) {
      let res = JSON.parse(JSON.stringify(response));
      state.stateData = _.merge({}, state.stateData, response)

      let listProducts = res.contract_detail_list
      state.stateData.list_products = listProducts;
      
		},
		getContractFailure(state) {
			Object.assign(state.stateData, getDefaultState())
		},
    getShipmentQuantityRemainSuccess(state, response) {
      let delivery_lists = response.delivery_voucher_lists;
      let receiving_lists = response.receiving_voucher_lists;
      
      if(delivery_lists.length > 0 && receiving_lists.length > 0) {
        if (state.stateData.list_products.length > 0){          
          state.stateData.list_products.forEach((item) => {
            let quantity_in = 0;
            let quantity_out = 0;
            receiving_lists.forEach(receiving => {
              if (receiving.product_id == parseInt(item.product_id)) {
                quantity_in += receiving.quantity_in;
              }
            });
            let quantity_in_remain = (parseFloat(item.quantity_in) - quantity_in) <= 0 ? 0 : (parseFloat(item.quantity_in) - quantity_in);
            item["quantity_in_contract"] = item["quantity_in"];
            item["quantity_in"] = quantity_in_remain;
            item["quantity_in_progressive"] = quantity_in;
            
            delivery_lists.forEach(receiving => {
              if (receiving.product_id == parseInt(item.product_id)) {
                quantity_out += receiving.quantity_out;
              }
            });
            let quantity_out_remain = (parseFloat(item.quantity_out) - quantity_out) <= 0 ? 0 : (parseFloat(item.quantity_out) - quantity_out);
            item["quantity_out_contract"] = item["quantity_out"];
            item["quantity_out"] = quantity_out_remain;
            item["quantity_out_progressive"] = quantity_out;

            // Calculate the quantity_in stock remain
            item["quantity_in_stock"] = (quantity_in - quantity_out) <= 0 ? 0 : (quantity_in - quantity_out);
          });
        }
      }
      else {
        state.stateData.list_products.forEach((item) => {
          item["quantity_in_progressive"] = 0;
          item["quantity_out_progressive"] = 0;
          item["quantity_in_stock"] = 0;
        })
      }
    },
    getShipmentQuantityRemainFailure(state) {
      state.stateData.list_products.forEach((item) => {
        item["quantity_in_progressive"] = 0;
        item["quantity_out_progressive"] = 0;
      })
    },
    uploadSuccess(state, response) {
      if (response.el_name == "file_1"){
        state.stateData.file_link_1 = response.image_names[0];
      }
			if (response.el_name == "file_2"){
        state.stateData.file_link_2 = response.image_names[0];
      }
      if (response.el_name == "file_3"){
        state.stateData.file_link_3 = response.image_names[0];
      }
      if (response.el_name == "file_4"){
        state.stateData.file_link_4 = response.image_names[0];
      }
		},
		uploadFailure(state) {
			state.stateData.file_link_1 = "";
      state.stateData.file_link_2 = "";
      state.stateData.file_link_3 = "";
      state.stateData.file_link_4 = "";
		},
    getSupplierInfoSuccess(state, payload) {
      state.stateData.supplierInfo = payload;
    },
    getSupplierInfoFailed(state) {
      state.stateData.supplierInfo = {};
    },
    getCustomerInfoSuccess(state, payload) {
      state.stateData.customerInfo = payload;
    },
    getCustomerInfoFailed(state) {
      state.stateData.customerInfo = {};
    },
    handleReCalculateGrandTotal(state) {
      if (state.isRecalculateLocked) return;

      let subTotalBuy = 0;
      let subTotalSell = 0;
      let taxBuy = 0;
      let taxSell = 0;
      
      state.stateData.list_products.forEach(p => {
        const qtyIn  = Number(p.quantity_in  || 0);
        const qtyOut = Number(p.quantity_out || 0);

        const buyAmount  = Number(p.buy_price)  * qtyIn;
        const sellAmount = Number(p.sell_price) * qtyOut;

        subTotalBuy  += buyAmount;
        subTotalSell += sellAmount;

        taxBuy  += calcTax(buyAmount,  p, 'buy');
        taxSell += calcTax(sellAmount, p, 'sell');
      });
      
      state.stateData.sub_total_buy  = subTotalBuy;
      state.stateData.tax_total_buy  = taxBuy;

      state.stateData.sub_total_sell = subTotalSell;
      state.stateData.tax_total_sell = taxSell;
      
      state.stateData.grand_total_buy_vnd = state.stateData.sub_total_buy * Number(state.stateData.buy_exchange_rates || 0);
      state.stateData.grand_total_sell_vnd = state.stateData.sub_total_sell * Number(state.stateData.sell_exchange_rates || 0);

      state.stateData.grand_total_buy_price  = subTotalBuy  + taxBuy;
      state.stateData.grand_total_sell_price = subTotalSell + taxSell;

      state.stateData.grand_total_buy_text = 
        state.stateData.grand_total_buy_price ? new Converter().toWords(state.stateData.grand_total_buy_price) : "";

      state.stateData.grand_total_sell_text =
        state.stateData.grand_total_sell_price ? new Converter().toWords(state.stateData.grand_total_sell_price): "";
    },
    updateProductQuantity(state, payload) {
      const product = state.stateData.list_products.find(
        p => p.product_id === payload.product_id
      );

      if (!product) return;

      if (payload.quantity_in !== undefined) {
        product.quantity_in = payload.quantity_in;
      }

      if (payload.quantity_out !== undefined) {
        product.quantity_out = payload.quantity_out;
      }
    },
    updateProductError(state, { product_id, error }) {
      // Remove old error
      state.stateData.error_lists =
        state.stateData.error_lists.filter(e => e.product_id !== product_id);

      // Add new error if exists
      if (error) {
        state.stateData.error_lists.push({
          product_id,
          "message": error.message
        });
      }
    },
    setRecalculateLock(state, value) {
      state.isRecalculateLocked = value;
    }
  },
  getters: {

  }
}